require('./css/style.css')
require('./css/loader.css')
require('./lib/kiosk/pasi.css')
require('./main')
